import $t from '../../../i18n'
import DatePicker from '../DatePicker/DatePicker'
import { Checkbox } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import MaterialSelectWithDropdown from '../MaterialSelectWithDropdown/MaterialSelectWithDropdown'
import { relationship } from '../../../consts'

import './MemberInfo.css'

const MemberInfo = ({
  member,
  errors,
  hideRelation,
  hideTitle,
  onChange = () => {}
}) => {
  const dispatch = useDispatch()

  const members = useSelector(state => state.member?.members)

  const { dob, sex, relation, isTobbacoUser, isElligible } = member

  const SpouseMember = members?.find(
    member => member.relation === relationship.spouse
  )

  const isOwner = member?.relation === relationship.owner

  // spouse can be added only if there is no spouse already
  // should show only dependent if spouse is already added and the current member is not spouse
  const shouldShowOnlyDependent =
    !!SpouseMember && SpouseMember?.id !== member?.id

  const sexOptions = [
    { label: $t('common.male'), value: 'male' },
    { label: $t('common.female'), value: 'female' }
  ]

  const relationOptions =
    shouldShowOnlyDependent && members
      ? [{ label: $t('common.dependent'), value: relationship.dependent }]
      : [
          { label: $t('common.spouse'), value: relationship.spouse },
          { label: $t('common.dependent'), value: relationship.dependent }
        ]

  const UpdateField = (key, value) => {
    onChange(key, value)
  }

  return (
    <div className='member-info'>
      {!hideTitle && (
        <div className='member-info-header semi-bold'>
          {isOwner
            ? $t('enroll.info.memberCard.headerMe')
            : $t('enroll.info.memberCard.headerFamily')}
          {!isOwner && (
            <div
              className='icon-oclose'
              onClick={() =>
                dispatch(
                  Actions.createAction(Actions.REMOVE_MEMBER, {
                    id: member?.id
                  })
                )
              }
            />
          )}
        </div>
      )}
      <div className='member-info-content'>
        {!isOwner && !hideRelation && (
          <div className='row space'>
            <div className='field streach relation'>
              <div className='field-title'>{$t('fields.relationship')}</div>
              <MaterialSelectWithDropdown
                className='relation-input'
                value={relation}
                onChange={relation => UpdateField('relation', relation)}
                errorText={errors?.relation}
                data={relationOptions}
                placeholder={$t('common.choose')}
              />
            </div>
          </div>
        )}
        <div className='row wrap space'>
          <div className='field dob'>
            <div className='field-title'>{$t('fields.dob')}</div>
            <DatePicker
              errorText={errors?.dob}
              defaultDob={dob}
              setSelectedDate={dob => UpdateField('dob', dob)}
            />
          </div>
          <div className='field streach'>
            <div className='field-title'>{$t('fields.sex')}</div>
            <div className='sex-toggle'>
              {sexOptions?.map((option, index) => {
                return (
                  <div
                    key={index}
                    data-selected={sex === option?.value}
                    onClick={() => UpdateField('sex', option?.value)}
                    className={`sex-option ${option?.value}`}
                  >
                    {option?.label}
                  </div>
                )
              })}
            </div>
            <div className='error'>{errors?.sex}</div>
          </div>
        </div>
        <div className='row'>
          <div className='field'>
            <div className='field-title'>
              {$t('enroll.info.memberCard.additionalDetails')}:
            </div>
            <Checkbox
              className='tobbaco-checkbox'
              onChange={() => UpdateField('isTobbacoUser', !isTobbacoUser)}
              checked={isTobbacoUser}
            >
              {$t('fields.tobaco')}
            </Checkbox>
            <Checkbox
              className='eligibility-checkbox'
              onChange={() => UpdateField('isElligible', !isElligible)}
              checked={isElligible}
            >
              {$t('enroll.info.memberCard.EligibleForCoverage')}
            </Checkbox>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MemberInfo
